import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "freelancer-price"
}
const _hoisted_2 = { slot: "tooltip-content" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_joy_text = _resolveComponent("joy-text")!
  const _component_freelancer_price_details = _resolveComponent("freelancer-price-details")!
  const _component_joy_tooltip_trigger = _resolveComponent("joy-tooltip-trigger")!

  return (_ctx.profile.price)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.withTooltips && _ctx.profile.price.details)
          ? (_openBlock(), _createBlock(_component_joy_tooltip_trigger, {
              key: 0,
              event: "mouseenter"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_joy_text, { slot: "tooltip-trigger" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_joy_icon, { name: "question-circle" })
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_2, [
                  _createVNode(_component_freelancer_price_details, { profile: _ctx.profile }, null, 8, ["profile"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("p", { innerHTML: _ctx.priceLabel }, null, 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}